import * as tslib_1 from "tslib";
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { LoginAttemptsService, } from '@services';
var LoginAttemptSource = /** @class */ (function () {
    function LoginAttemptSource(_loginAttempts) {
        this._loginAttempts = _loginAttempts;
    }
    Object.defineProperty(LoginAttemptSource.prototype, "mapper", {
        get: function () {
            return this._loginAttempts.mapper;
        },
        enumerable: true,
        configurable: true
    });
    LoginAttemptSource.prototype.get = function (qo) {
        return this._loginAttempts.getInstanceSet(this.userId, qo);
    };
    return LoginAttemptSource;
}());
export { LoginAttemptSource };
var UiLoginAttemptsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiLoginAttemptsGridComponent, _super);
    function UiLoginAttemptsGridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UiLoginAttemptsGridComponent.prototype, "userId", {
        set: function (value) {
            var svc = this._service;
            if (!svc ||
                isNaN(value) ||
                svc.userId === value) {
                return;
            }
            svc.userId = value;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    return UiLoginAttemptsGridComponent;
}(ODataGridComponent));
export { UiLoginAttemptsGridComponent };
